import React, { useEffect, useState } from 'react'
import Home from './Home'
import About from '../About/About'
import Career from '../Career/Career'
import Contact from '../Contact/Contact'
import "../App.css"
import Projects from '../Products/Products'
import { collection, doc, getDoc, getDocs, limit, orderBy, query } from 'firebase/firestore'
import { db } from '../Config/Config'

export default function MainPage() {
  const [projects, setProjects] = useState([]);
  const [homeData, setHomeData] = useState({});
  const [aboutData, setAboutData] = useState({});
  const [careerData, setCareerData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHomeData = async () => {
    try {
      const docRef = doc(db, "website-data", "home-page");
      const snapshot = await getDoc(docRef);

      if (snapshot.exists()) {
        setHomeData(snapshot.data());
        console.log("Fetched home data:", snapshot.data());
      } else {
        console.warn("No such document: home-page");
        setHomeData({});
      }
    } catch (error) {
      console.error("Error fetching home-page data:", error);
    }
  };

  const fetchAboutData = async () => {
    try {
      const docRef = doc(db, "website-data", "about-us");
      const snapshot = await getDoc(docRef);

      if (snapshot.exists()) {
        setAboutData(snapshot.data());
        console.log("Fetched about data:", snapshot.data());
      } else {
        console.warn("No such document: about-us");
        setAboutData({});
      }
    } catch (error) {
      console.error("Error fetching about-us data:", error);
    }
  };

  const fetchCareerData = async () => {
    try {
      const docRef = doc(db, "website-data", "careers");
      const snapshot = await getDoc(docRef);

      if (snapshot.exists()) {
        setCareerData(snapshot.data());
        console.log("Career Data:", snapshot.data());
        console.log("Fetched career data:", snapshot.data());
      } else {
        console.warn("No such document: career");
        setCareerData({});
      }
    } catch (error) {
      console.error("Error fetching career data:", error);
    }
  };

  const fetchContactData = async () => {
    try {
      const docRef = doc(db, "website-data", "contact-us");
      const snapshot = await getDoc(docRef);

      if (snapshot.exists()) {
        setContactData(snapshot.data());
        console.log("Fetched contact data:", snapshot.data());
      } else {
        console.warn("No such document: contact");
        setContactData({});
      }
    } catch (error) {
      console.error("Error fetching contact data:", error);
    }
  };

  const fetchProjects = async () => {
    try {
      const q = query(
        collection(db, "projects-website"),
        orderBy('order', 'asc'),
        limit(6)
      );
      const querySnapshot = await getDocs(q);
      const projectData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProjects(projectData);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };


  useEffect(() => {
    (async () => {
      await Promise.all([
        fetchProjects(),
        fetchHomeData(),
        fetchAboutData(),
        fetchCareerData(),
        fetchContactData(),
      ]);
      setLoading(false);
    })();
  }, []);

  return (
    <div className=''>
      {loading ? (
        <div className="relative bg-primary-dark h-[100svh] overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat md:bg-cover md:bg-fixed"
            style={{
              backgroundImage: "url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1600&auto=format&fit=crop')",
            }}
          />
          <div className="absolute inset-0 bg-black/60" />
          <div className="relative z-10 h-[100svh] flex flex-col items-center justify-center gap-4">
            <img src="/Logo.png" alt="Logo" className="h-14 w-auto opacity-90" />
            <div className="h-8 w-8 rounded-full border-2 border-white/60 border-t-transparent animate-spin" />
          </div>
        </div>
      ) : (
        <>
          {/* Background with Image for Home and About */}
          <div className="relative bg-primary-dark min-h-[100svh] md:min-h-0">
            <div className="absolute inset-0 z-0">
              <div className="absolute inset-0 bg-gradient-to-r from-primary-dark/90 via-primary-dark/80 to-primary-dark/60 md:from-primary-dark/80 md:via-primary-dark/50 md:to-primary-dark/20 z-10" />
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-scroll md:bg-cover md:bg-fixed"
                style={{
                  backgroundImage: "url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1600&auto=format&fit=crop')",
                }}
              />
            </div>

            <div className="relative z-10 min-h-[100svh] md:min-h-0">
              <Home homeData={homeData} />
            </div>
          </div>

          {/* Solid Dark Background for Projects, Career, Contact */}
          <div className="bg-primary-dark">
            <main>
              <About aboutData={aboutData} />
              {projects.length > 0 && <Projects projects={projects} />}
              <Career careerData={careerData} />
              <Contact contactData={contactData} />
            </main>
          </div>
        </>
      )}
    </div>
  )
}
